// extracted by mini-css-extract-plugin
export default {"layout":"Configurations_layout__8tmr1","start":"Configurations_start__8+fMm","markdown":"Configurations_markdown__7k4Bd","examples":"Configurations_examples__VoZAc"};